import React from 'react';
import CartIcon from './CartIcon';

interface CartButtonProps {
  onClick: () => void;
  className?: string;
}

const CartButton: React.FC<CartButtonProps> = ({ 
  onClick, 
  className = '' 
}) => {
  return (
    <div className={`relative ${className}`}>
      <CartIcon 
        onClick={onClick}
      />
    </div>
  );
};

export default CartButton; 